import JSZip from "jszip";

export const generateZip = (files, zipFileName) => {
    if (files.length) {
        let zip = JSZip();
        for (const file of files) {
            zip.file(`${file.name}`, file, {
                binary: true
            });
        }
        return zip.generateAsync({type: "blob"}).then(content => {
            // saveAs(content, "test_archive.zip");
            return new File([content], zipFileName)
        });
    }
    return null
}